export enum Dialect {
    sqlite = "sqlite",
    mysql = "mysql",
    postgresql = "postgresql"
}